var _g, _g2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSabeqoonIconColored06(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 38.62 49.46",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M37.9,42.54H3.82V.72h33.3c.43,0,.77.35.77.77v41.05Z",
    fill: "#fff",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.47,5.37v12.39h1.55c0-.86.69-1.55,1.55-1.55h.77c.43,0,.77-.35.77-.77v-2.32c0-1.71,1.39-3.1,3.1-3.1h2.32c.43,0,.77-.35.77-.77v-.77c0-.86.69-1.55,1.55-1.55s1.55.69,1.55,1.55v.77c0,.43.35.77.77.77h2.32c1.71,0,3.1,1.39,3.1,3.1v2.32c0,.43.35.77.77.77h.77c.86,0,1.55.69,1.55,1.55h1.55V5.37H8.47Z",
    fill: "#fcb814",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.25,37.9v-12.39h-1.55c0,.86-.69,1.55-1.55,1.55h-.77c-.43,0-.77.35-.77.77v2.32c0,1.71-1.39,3.1-3.1,3.1h-2.32c-.43,0-.77.35-.77.77v.77c0,.86-.69,1.55-1.55,1.55s-1.55-.69-1.55-1.55v-.77c0-.43-.35-.77-.77-.77h-2.32c-1.71,0-3.1-1.39-3.1-3.1v-2.32c0-.43-.35-.77-.77-.77h-.77c-.86,0-1.55-.69-1.55-1.55h-1.55v12.39h24.78Z",
    fill: "#fcb814",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("path", {
    d: "M.72,44.87V3.05C.72,1.76,1.76.72,3.05.72h.77v41.82l-3.1,2.32Z",
    fill: "#f2f2f2",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.8,3.82H6.92v35.62h27.88V3.82ZM31.7,36.35H10.02V6.92h21.68v29.43Z",
    fill: "#fcb814",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.51,21.63c0-1.72-.94-3.22-2.32-4.02v-.63c0-1.28-1.04-2.32-2.32-2.32s-2.32,1.04-2.32,2.32v.63c-1.39.8-2.32,2.3-2.32,4.02s.94,3.22,2.32,4.02v.63c0,1.28,1.04,2.32,2.32,2.32s2.32-1.04,2.32-2.32v-.63c1.39-.8,2.32-2.3,2.32-4.02h0Z",
    fill: "#fcb814",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 20.86,
    cy: 21.63,
    r: 1.55,
    fill: "#fcb814",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.12.72h-1.6v38.67c0,.43-.35.77-.77.77H3.82v2.38h33.3c.43,0,.77-.35.77-.77V1.5c0-.43-.35-.77-.77-.77h0Z",
    fill: "#fff",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.05,48.74h33.3v-6.2H3.05c-1.28,0-2.32,1.04-2.32,2.32v1.55c0,1.28,1.04,2.32,2.32,2.32h0Z",
    fill: "#f2f2f2",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.03,42.54h2.32v6.2h-2.32v-6.2Z",
    fill: "#f2f2f2",
    strokeWidth: 0
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M37.07,43.27h.05c.83,0,1.5-.67,1.5-1.5V1.5c0-.83-.67-1.5-1.5-1.5H3.05C1.37,0,0,1.37,0,3.05v43.37c0,1.68,1.37,3.05,3.05,3.05h34.85c.4,0,.72-.32.72-.72s-.32-.72-.72-.72h-.82v-4.75ZM37.17,1.5v40.27s-.02.05-.05.05H4.55V1.45h32.58s.05.02.05.05h0ZM1.45,3.05c0-.88.72-1.6,1.6-1.6h.05v40.37h-.05c-.59,0-1.13.17-1.6.45V3.05ZM3.05,48.02c-.88,0-1.6-.72-1.6-1.6v-1.55c0-.88.72-1.6,1.6-1.6h32.58v1.65H3.82c-.4,0-.72.32-.72.72s.32.72.72.72h31.8v1.65H3.05Z",
    fill: "#000",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.92,35.62c-.4,0-.72.32-.72.72v3.1c0,.4.32.72.72.72h27.88c.4,0,.72-.32.72-.72V3.82c0-.4-.32-.72-.72-.72H6.92c-.4,0-.72.32-.72.72v29.43c0,.4.32.72.72.72s.72-.32.72-.72V4.55h26.43v34.18H7.64v-2.37c0-.4-.32-.72-.72-.72Z",
    fill: "#000",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.7,9.97c.4,0,.72-.32.72-.72v-2.32c0-.4-.32-.72-.72-.72H10.02c-.4,0-.72.32-.72.72v29.43c0,.4.32.72.72.72h21.68c.4,0,.72-.32.72-.72V12.34c0-.4-.32-.72-.72-.72s-.72.32-.72.72v3.3c-.26-.1-.53-.16-.82-.16h-.82v-2.37c0-2.11-1.71-3.82-3.82-3.82h-2.37v-.82c0-.29-.06-.57-.16-.82h8v1.6c0,.4.32.72.72.72h0ZM18.74,7.64c-.1.26-.16.53-.16.82v.82h-2.37c-2.11,0-3.82,1.71-3.82,3.82v2.37h-.82c-.29,0-.57.06-.82.16v-8h8ZM10.74,27.63c.26.1.53.16.82.16h.82v2.37c0,2.11,1.71,3.82,3.82,3.82h2.37v.82c0,.29.06.57.16.82h-8v-8ZM22.98,35.62c.1-.26.16-.53.16-.82v-.82h2.37c2.11,0,3.82-1.71,3.82-3.82v-2.37h.82c.29,0,.57-.06.82-.16v8h-8ZM21.68,8.47v1.55c0,.4.32.72.72.72h3.1c1.31,0,2.37,1.06,2.37,2.37v3.1c0,.4.32.72.72.72h1.55c.45,0,.82.37.82.82v7.74h0c0,.46-.37.83-.82.83h-1.55c-.4,0-.72.32-.72.72v3.1c0,1.31-1.06,2.37-2.37,2.37h-3.1c-.4,0-.72.32-.72.72v1.55c0,.45-.37.82-.82.82s-.82-.37-.82-.82v-1.55c0-.4-.32-.72-.72-.72h-3.1c-1.31,0-2.37-1.06-2.37-2.37v-3.1c0-.4-.32-.72-.72-.72h-1.55c-.45,0-.82-.37-.82-.82v-7.75c0-.45.37-.82.82-.82h1.55c.4,0,.72-.32.72-.72v-3.1c0-1.31,1.06-2.37,2.37-2.37h3.1c.4,0,.72-.32.72-.72v-1.55c0-.45.37-.82.82-.82s.82.37.82.82h0Z",
    fill: "#000",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.14,14.03c-1.33.33-2.32,1.53-2.32,2.96v.23c-1.44,1-2.32,2.65-2.32,4.42s.88,3.42,2.32,4.42v.23c0,1.43.99,2.63,2.32,2.96v.91c0,.4.32.72.72.72s.72-.32.72-.72v-.91c1.33-.33,2.32-1.53,2.32-2.96v-.23c1.44-1,2.32-2.65,2.32-4.42s-.88-3.42-2.32-4.42v-.23c0-1.43-.99-2.63-2.32-2.96v-.91c0-.4-.32-.72-.72-.72s-.72.32-.72.72v.91ZM22.46,16.99v.63c0,.26.14.5.36.63,1.21.7,1.96,2,1.96,3.39s-.75,2.69-1.96,3.39c-.22.13-.36.37-.36.63v.63c0,.88-.72,1.6-1.6,1.6s-1.6-.72-1.6-1.6v-.63c0-.26-.14-.5-.36-.63-1.21-.7-1.96-2-1.96-3.39s.75-2.69,1.96-3.39c.22-.13.36-.37.36-.63v-.63c0-.88.72-1.6,1.6-1.6s1.6.72,1.6,1.6Z",
    fill: "#000",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.59,21.63c0,1.25,1.02,2.27,2.27,2.27s2.27-1.02,2.27-2.27-1.02-2.27-2.27-2.27-2.27,1.02-2.27,2.27h0ZM21.68,21.63c0,.45-.37.82-.82.82s-.82-.37-.82-.82.37-.82.82-.82.82.37.82.82Z",
    fill: "#000",
    strokeWidth: 0
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSabeqoonIconColored06);
export default __webpack_public_path__ + "static/media/Sabeqoon_Icon_Colored_06.b2e2a41e8251d1d990abf6ef4d69c6c6.svg";
export { ForwardRef as ReactComponent };